import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { GlobalConfig, ToastContainerDirective, ToastrService } from "ngx-toastr";
import { CustomToastComponent } from "../custom-toast/custom-toast.component";
import { ToastService } from "../../../services/internal-services/toast.service";
import { IVisionToast } from "../../../interfaces/i-vision-toast";
import { TOAST_STATUS } from "../../../model/ToastConstants";

@Component({
  selector: "app-vision-toast",
  templateUrl: "./vision-toast.component.html",
  styleUrls: ["./vision-toast.component.scss"],
  providers: [ToastrService],
  standalone: false,
})
export class VisionToastComponent implements OnInit {
  @ViewChild(ToastContainerDirective, { static: true })
  toastContainer: ToastContainerDirective;

  options: GlobalConfig;

  @Input()
  set notification(toast: IVisionToast) {
    if (toast) {
      this.createToast(toast);
    }
  }

  @Input()
  set remove(id: number) {
    if (id) {
      this.toastrService.clear(id);
    }
  }

  @Input()
  set removeAll(remove: boolean) {
    if (remove) {
      this.toastrService.clear();
    }
  }

  constructor(
    private toastrService: ToastrService,
    private visionToastService: ToastService,
  ) {
    this.options = this.toastrService.toastrConfig;
  }

  ngOnInit() {
    this.toastrService.overlayContainer = this.toastContainer;
    this.options.toastComponent = CustomToastComponent;
    this.options.positionClass = "toast-bottom-center";
    this.options.messageClass = "toast-text";
    this.options.titleClass = "toast-text";
    this.options.preventDuplicates = true;
    this.options.tapToDismiss = false;
    this.options.enableHtml = true;
  }

  createToast(toast: IVisionToast): void {
    /* override standard behaviour when the toast have set a timeout */
    const options = { ...this.options };
    if (toast.timeout) {
      options.timeOut = toast.timeout;
      options.disableTimeOut = false;
    }
    if (toast.extendedTimeOut !== undefined) {
      options.extendedTimeOut = toast.extendedTimeOut;
      options.disableTimeOut = false;
    }
    if (toast.disableTimeOut) {
      options.disableTimeOut = true;
    }
    if (toast.positionClass) {
      options.positionClass = toast.positionClass;
    }
    if (toast.status) {
      options.toastClass = toast.status;
    }
    if (toast.progressBar) {
      options.progressBar = toast.progressBar;
    }
    if (toast.closeButton !== undefined) {
      options.closeButton = toast.closeButton;
    } else {
      options.closeButton = true;
    }

    if (toast.id) {
      options.toastClass = toast.id;
    }

    let finalToast;
    switch (toast.type) {
      case TOAST_STATUS.WARNING:
        finalToast = this.toastrService.warning(toast.message, toast.title, options);
        break;
      case TOAST_STATUS.ERROR:
        finalToast = this.toastrService.error(toast.message, toast.title, options);
        break;
      case TOAST_STATUS.SUCCESS:
        finalToast = this.toastrService.success(toast.message, toast.title, options);
        break;
      default:
        finalToast = this.toastrService.show(toast.message, toast.title, options);
        break;
    }

    toast.toastId = finalToast.toastId;
    finalToast.onHidden.subscribe(() => {
      setTimeout(
        (visionToastService, toastrService) => {
          visionToastService.checkToasts(toastrService.toasts);
        },
        0,
        this.visionToastService,
        this.toastrService,
      );
    });

    // Needed for avoid toast hide when hover
    if (toast.extendedTimeOut === 0 && options.timeOut) {
      finalToast.onShown.subscribe(() => {
        setTimeout(() => {
          finalToast.toastRef.manualClose();
        }, options.timeOut);
      });
    }
  }
}
